import React from 'react';

const CommunityPage: React.FC = () => {
  return (
    <div style={{ padding: '50px', textAlign: 'center' }}>
      <h1>자유게시판</h1>
      <p>커뮤니티 멤버들이 자유롭게 소통할 수 있는 게시판입니다.</p>
      <p>추후 구현 예정입니다.</p>
    </div>
  );
};

export default CommunityPage;